module.exports = __webpack_public_path__ + "img/SKMJ_limit6.d227b1d8.jpg";